export default __webpack_public_path__ + "static/media/travel.9b718b83.svg";